import PropTypes from 'prop-types';
import React from 'react';

const ArrowLongLeft = ({ color }) => {
  return (
    <svg
      fill="none"
      height="7"
      viewBox="0 0 15 7"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3989 3.43213L2.87826 3.43213"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M0.957824 3.43259L4.79803 -5.42183e-05L4.79803 6.86523L0.957824 3.43259Z"
        fill={color}
      />
    </svg>
  );
};

ArrowLongLeft.propTypes = {
  color: PropTypes.string,
};

export default ArrowLongLeft;
